module.exports = __webpack_public_path__ + "static/media/onion.d8bfbe71.png";